export default __webpack_public_path__ + "static/media/1415.5ce41242.png";